import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { Group, log, error } from "../../utils/logger";
import { faEdit, faExclamationCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import React, { Fragment } from "react";
import moment from "moment-timezone";
import { encryption } from "../../utils/data.crypt";
import {
  TEMPLATE_ERROR,
  TEMPLATE_LOADING,
  SET_TEMPLATES,
  GET_EDITOR_INFORMATION_ERROR,
  GET_EDITOR_INFORMATION_LOADING,
  GET_EDITOR_INFORMATION,
  EDITOR_DATABASE_UPDATE,
  EDITOR_DATABASE_UPDATE_ERROR,
  GET_TEMPLATE_HISTORY,
  GET_TEMPLATE_HISTORY_ERROR,
  GET_CURRENT_TEMPLATE_FOR_APPROVAL_INFO,
  GET_CURRENT_TEMPLATE_FOR_APPROVAL_LOADING,
  GET_CURRENT_TEMPLATE_FOR_APPROVAL_ERROR,
  GET_DRAFT_TEMPLATE_FOR_APPROVAL_INFO,
  GET_DRAFT_TEMPLATE_FOR_APPROVAL_LOADING,
  GET_DRAFT_TEMPLATE_FOR_APPROVAL_ERROR,
  APPROVAL_DRAFT,
  APPROVAL_DRAFT_ERROR,
  GET_COMMENTS_APPROVAL_INFO,
  GET_COMMENTS_APPROVAL_LOADING,
  GET_COMMENTS_APPROVAL_ERROR,
  SET_SELECTED_OPTIONS,
  SET_ON_DEMAND_TEMPLATES,
} from "../constants";

import store from "../store";
import { Button } from "reactstrap";

const LoggerGroup = new Group("Templates Actions", { disable: false });

export const templatesLoading = (type) => (dispatch) => {
  dispatch({ type: TEMPLATE_LOADING, payload: type });
};

export const setSelectedOptions = (type) => (dispatch) => {
  dispatch({ type: SET_SELECTED_OPTIONS, payload: type });
};

export const templatesLoadingForEditor = (type) => (dispatch) => {
  dispatch({ type: GET_EDITOR_INFORMATION_LOADING, payload: type });
};

export const currentTemplateLoadingForApproval = (type) => (dispatch) => {
  dispatch({ type: GET_CURRENT_TEMPLATE_FOR_APPROVAL_LOADING, payload: type });
};

export const draftTemplateLoadingForApproval = (type) => (dispatch) => {
  dispatch({ type: GET_DRAFT_TEMPLATE_FOR_APPROVAL_LOADING, payload: type });
};

export const editorDraftDatabaseUpdate = (response) => {
  return {
    type: EDITOR_DATABASE_UPDATE,
    response: response,
  };
};

export const insertAprovalDraft = (response) => {
  return {
    type: APPROVAL_DRAFT,
    response: response,
  };
};

export const getCommentsLoading = (response) => {
  return {
    type: GET_COMMENTS_APPROVAL_LOADING,
    response: response,
  };
};

export const getDraftTemplateForApproval = (smsCurrentTemplateId, emailCurrentTemplateId) => (
  dispatch
) => {
  dispatch(draftTemplateLoadingForApproval("templates"));

  return axios({
    url: `templates/get-email-and-sms-approval-draft/${emailCurrentTemplateId}/${smsCurrentTemplateId}`,
    method: "get",
    params: {},
  })
    .then((res) => {
      const templates = get(res, "data");
      LoggerGroup.emit("Draft Template Approval Response", { dir: res });
      if (templates) {
        let dataCombined = { ...templates.emailDraft, ...templates.smsDraft };
        LoggerGroup.emit("  [i] List of templates", { table: templates }).end();
        dispatch({ type: GET_DRAFT_TEMPLATE_FOR_APPROVAL_INFO, payload: dataCombined });
      }
    })
    .catch((err) => {
      LoggerGroup.emit({ warn: "[i] Error getting templates" }, { dir: err.response }).end();
      dispatch({
        type: GET_DRAFT_TEMPLATE_FOR_APPROVAL_ERROR,
        payload: { template_payload: "Error getting templates" },
      });
    });
};

export const getCurrentTemplateForApproval = (smsCurrentTemplateId, emailCurrentTemplateId) => (
  dispatch
) => {
  dispatch(currentTemplateLoadingForApproval("templates"));

  let requestArray = [];
  let sms;
  let email;

  if (smsCurrentTemplateId.templateId) {
    sms = `templates/get-template-by-template-id/sms/${smsCurrentTemplateId.templateId}`;
    requestArray.push(axios.get(sms));
  }
  if (emailCurrentTemplateId.templateId) {
    email = `templates/get-template-by-template-id/email/${emailCurrentTemplateId.templateId}`;
    requestArray.push(axios.get(email));
  }

  return axios
    .all(requestArray)
    .then(
      axios.spread((...responses) => {
        let dataCombined = responses.map((r) => r.data.template[0]);
        if (dataCombined.length > 1) {
          dataCombined = { ...dataCombined[0], ...dataCombined[1] };
        } else {
          dataCombined = { ...dataCombined[0] };
        }

        // use/access the results
        dispatch({ type: GET_CURRENT_TEMPLATE_FOR_APPROVAL_INFO, payload: dataCombined });
      })
    )
    .catch((err) => {
      LoggerGroup.emit(
        { warn: "[i] Error Getting Editor information" },
        { dir: err.response }
      ).end();
      dispatch({
        type: GET_CURRENT_TEMPLATE_FOR_APPROVAL_ERROR,
        payload: { approval_current_payload: err },
      });
    });
};

export const getTemplates = (include = "active", user) => (dispatch) => {
  dispatch(templatesLoading("templates"));
  LoggerGroup.emit("[i] Updating list of templates");
  return axios({
    url: `templates/get-all-templates`,
    method: "get",
    params: { include },
  })
    .then((res) => {
      const templates = get(res, "data.templates");
      if (templates) {
        for (let index = 0; index < templates.length; ++index) {
          let approvalStatus = false;
          let data = templates[index];
          data.companyCode = data.companycode_vch.replace(/ /g, "");
          if (data.subtype === "") {
            data.subtype = "NO_SUBTYPE";
          }
          if (data.sendForApproval) {
            approvalStatus = true;
          }

          if (data.sms_updated_at) {
            data.Updated_At = moment(data.sms_updated_at)
              .tz("America/Chicago")
              .format("YYYY-MM-DD h:mm a");

            if (data.email_updated_at) {
              if (
                moment(data.email_updated_at).isAfter(data.sms_updated_at) ||
                moment(data.email_updated_at).isSame(data.sms_updated_at)
              ) {
                data.Updated_At = moment(data.email_updated_at)
                  .tz("America/Chicago")
                  .format("YYYY-MM-DD h:mm a");
              }
            }
          } else {
            data.Updated_At = moment(data.email_updated_at)
              .tz("America/Chicago")
              .format("YYYY-MM-DD h:mm a");
          }

          //hiding internal for less
          if (user < 4 && data.companyCode === "Internal") {
            delete templates[index];
          }

          data.actions = (
            <Fragment>
              <Link
                to={{
                  pathname: "/templates/history",
                  state: {
                    emailTemplateId: data.EmailTemplateId,
                    smsTemplateId: data.SmsTemplateId,
                    approvalStatus: approvalStatus,
                    subtype: data.subtype,
                    type: data.type,
                    companyCode: data.companycode_vch,
                  },
                }}
              >
                <FontAwesomeIcon icon={faEdit} size="2x" />
              </Link>
              {approvalStatus === true && user > 2 ? (
                <Link
                  to={{
                    pathname: "/templates/approval",
                    state: {
                      emailTemplateId: data.EmailTemplateId,
                      smsTemplateId: data.SmsTemplateId,
                      approvalStatus: approvalStatus,
                      subtype: data.subtype,
                      type: data.type,
                      companyCode: data.companycode_vch,
                    },
                  }}
                >
                  <FontAwesomeIcon icon={faExclamationCircle} color="red" size="2x" />
                </Link>
              ) : (
                ""
              )}
            </Fragment>
          );

          delete data.EmailTemplateId;
          delete data.SmsTemplateId;
          delete data.companycode_vch;
          delete data.EmailApprovalStatus;
          delete data.SMSApprovalStatus;
        }

        LoggerGroup.emit("  [i] List of templates", { table: templates }).end();
        dispatch({ type: SET_TEMPLATES, payload: templates });
      }
    })
    .catch((err) => {
      LoggerGroup.emit({ warn: "[i] Error getting templates" }, { dir: err.response }).end();
      dispatch({ type: TEMPLATE_ERROR, payload: { template_payload: "Error getting templates" } });
    });
};

export const getComments = (emailId, smsId) => (dispatch) => {
  dispatch(getCommentsLoading("comments"));
  LoggerGroup.emit("[i] Getting Comments");

  emailId = !emailId ? "null" : emailId;
  smsId = !smsId ? "null" : smsId;

  return axios({
    url: `templates/get-email-sms-draft-comments/${emailId}/${smsId}`,
    method: "get",
    params: {},
  })
    .then((res) => {
      log("getComments Response", res);
      const comments = res.data.comments;
      if (comments) {
        log("getComments Response: comments", comments);
        dispatch({ type: GET_COMMENTS_APPROVAL_INFO, payload: comments });
      }
    })
    .catch((err) => {
      LoggerGroup.emit({ warn: "[i] Error getting templates" }, { dir: err.response }).end();
      dispatch({ type: GET_COMMENTS_APPROVAL_ERROR, payload: { errors: err } });
    });
};

// Action for get history drafts data on behalf of smsTemplateId and emailTemplateId.
export const getHistoryTemplates = (email_template_id, sms_template_id, breadcrumb) => (
  dispatch
) => {
  dispatch(templatesLoading("templates"));

  const user = store.getState().user.user;

  return axios({
    url: `templates/get-email-sms-history/${email_template_id}/${sms_template_id}`,
    method: "get",
    params: {},
  })
    .then((res) => {
      const historyTemplates = get(res, "data");

      if (historyTemplates) {
        for (let index = 0; index < historyTemplates.length; ++index) {
          let data = historyTemplates[index];

          if (data.EmailRevisionId) {
            data.Revision = data.EmailRevisionId;
          }

          if (data.SMSRevisionId) {
            data.Revision = data.SMSRevisionId;
          }

          if (data.EmailCreatedDateTime) {
            data.Status_TimeStamp = data.EmailCreatedDateTime;
          }
          if (data.SMSCreatedDateTime) {
            data.Status_TimeStamp = data.SMSCreatedDateTime;
          }

          if (data.SMSCreatedby) {
            data.Creator = data.SMSCreatedby;
          }

          if (data.EmailCreatedby) {
            data.Creator = data.EmailCreatedby;
          }

          if (data.EmailApprovalStatus === 0 || data.SMSApprovalStatus === 0) {
            data.Status = " ";
          }

          if (data.EmailApprovalStatus === 1 || data.SMSApprovalStatus === 1) {
            data.Status = "Pending Approval";
          }
          if (data.EmailApprovalStatus === 2 || data.SMSApprovalStatus === 2) {
            data.Status = "Approved";
          }
          if (data.EmailApprovalStatus === 3 || data.SMSApprovalStatus === 3) {
            data.Status = "Rejection";
          }

          if (data.EmailApprovedBy === "undefined") {
            data.EmailApprovedBy = "";
          }
          if (data.SMSApprovedBy === "undefined") {
            data.SMSApprovedBy = "";
          }

          if (data.SMSApprovedBy) {
            data.admin = data.SMSApprovedBy;
          } else {
            data.admin = data.EmailApprovedBy;
          }

          data.Status_TimeStamp = moment(data.Status_TimeStamp)
            .tz("America/Chicago")
            .format("YYYY-MM-DD h:mm a");

          let email_delete_payload;
          let sms_delete_payload;

          if (data.EmailTemplateId) {
            email_delete_payload = {
              template_id: data.EmailTemplateId,
              revision_id: data.EmailRevisionId,
            };
          }

          if (data.SMSTemplateId) {
            sms_delete_payload = {
              template_id: data.SMSTemplateId,
              revision_id: data.SMSRevisionId,
            };
          }

          data.actions = (
            <Fragment>
              <Link
                to={{
                  pathname: "/templates/editor",
                  state: {
                    emailTemplateId: data.EmailTemplateId,
                    emailRevisionId: data.EmailRevisionId,
                    smsRevisionId: data.SMSRevisionId,
                    smsTemplateId: data.SMSTemplateId,
                    approvalStatus: breadcrumb.approvalStatus,
                    subtype: breadcrumb.subtype,
                    type: breadcrumb.type,
                    companyCode: breadcrumb.companyCode,
                  },
                }}
              >
                <FontAwesomeIcon icon={faEdit} size="2x" />
              </Link>
              &nbsp;
              {(data.SMSRevisionId || data.EmailRevisionId) &&
              user &&
              user.group_id_bint > 1 &&
              data.Status !== "Pending Approval" ? (
                <Link
                  to={{
                    pathname: "/templates/list",
                    state: {},
                  }}
                  onClick={getDeleteDrafts(sms_delete_payload, email_delete_payload)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} size="2x" />
                </Link>
              ) : (
                ""
              )}
            </Fragment>
          );

          if (!data.EmailCreatedby) {
            delete data.EmailCreatedby;
          }

          if (!data.EmailCreatedDateTime) {
            delete data.EmailCreatedDateTime;
          }
          if (!data.SMSCreatedby) {
            delete data.SMSCreatedby;
          }

          if (!data.SMSCreatedDateTime) {
            delete data.SMSCreatedDateTime;
          }

          delete data.EmailCreatedby;
          delete data.SMSCreatedby;
          delete data.SMSCreatedDateTime;
          delete data.EmailCreatedDateTime;
          delete data.SMSApprovedBy;
          delete data.EmailApprovedBy;
          delete data.SMSTemplateId;
          delete data.EmailRevisionId;
          delete data.SMSRevisionId;
          delete data.EmailTemplateId;
          delete data.EmailApprovalStatus;
          delete data.SMSApprovalStatus;
        }
        log("getHistoryTemplates", historyTemplates);
        LoggerGroup.emit(" [i] List of Drafts", { table: historyTemplates }).end();
        dispatch({ type: GET_TEMPLATE_HISTORY, payload: historyTemplates });
      }
    })
    .catch((err) => {
      LoggerGroup.emit({ warn: " [i] Error getting templates" }, { dir: err.response }).end();
      dispatch({
        type: GET_TEMPLATE_HISTORY_ERROR,
        payload: { template_payload: " Error getting template history" },
      });
    });
};

export const getTemplateForEditor = (
  smsTemplateData,
  emailTemplateData,
  smsLiveTemplateData,
  emailLiveTemplateData
) => (dispatch) => {
  dispatch(templatesLoadingForEditor("templates"));

  let requestArray = [];
  let sms;
  let email;

  if (smsTemplateData && smsTemplateData.revisionid) {
    sms = `templates/get-draft-by-template-and-revison/sms/${smsTemplateData.templateid}/${smsTemplateData.revisionid}`;
    requestArray.push(axios.get(sms));
  }

  if (emailTemplateData && emailTemplateData.revisionid) {
    email = `templates/get-draft-by-template-and-revison/email/${emailTemplateData.templateid}/${emailTemplateData.revisionid}`;
    requestArray.push(axios.get(email));
  }

  if (smsLiveTemplateData && !smsTemplateData) {
    sms = `templates/get-template-by-template-id/sms/${smsLiveTemplateData.templateid}/`;
    requestArray.push(axios.get(sms));
  }

  if (emailLiveTemplateData && !emailTemplateData) {
    email = `templates/get-template-by-template-id/email/${emailLiveTemplateData.templateid}/`;
    requestArray.push(axios.get(email));
  }

  return axios
    .all(requestArray)
    .then(
      axios.spread((...responses) => {
        let dataCombined = responses.map((r) => r.data.template[0]);
        if (dataCombined.length > 1) {
          dataCombined = { ...dataCombined[0], ...dataCombined[1] };
        } else {
          dataCombined = { ...dataCombined[0] };
        }

        // use/access the results
        dispatch({ type: GET_EDITOR_INFORMATION, payload: dataCombined });
      })
    )
    .catch((err) => {
      LoggerGroup.emit(
        { warn: "[i] Error Getting Editor information" },
        { dir: err.response }
      ).end();
      dispatch({ type: GET_EDITOR_INFORMATION_ERROR, payload: { template_editor_payload: err } });
    });
};

export const insertDraft = (payload, approval = 0) => (dispatch) => {
  dispatch(editorDraftDatabaseUpdate("updating"));

  //{email: { } , sms:{ } , sentForApproval : 0/1}
  //{email:{}, sentForApproval:0/1 }
  LoggerGroup.emit("[i] Updating SmS Draft Database");
  if (approval === 1) {
    payload.sentForApproval = 1;
  }

  payload = JSON.stringify(payload);
  payload = encryption(process.env.REACT_APP_API_CRYPTO_KEY, payload);

  return axios({
    url: `templates/create-draft/ `,
    method: "post",
    params: {},
    data: payload,
  })
    .then((res) => {
      const templates = res.status;
      if (templates) {
        LoggerGroup.emit("  [i] Status from DB insert", { table: templates }).end();
        dispatch({ type: EDITOR_DATABASE_UPDATE, template_editor_payload: res });
      }
    })
    .catch((err) => {
      LoggerGroup.emit(
        { warn: "[i] Error Getting Editor information" },
        { dir: err.response }
      ).end();
      dispatch({ type: EDITOR_DATABASE_UPDATE_ERROR, payload: { template_editor_payload: err } });
    });
};

export const approveDraft = (payload) => (dispatch) => {
  dispatch(insertAprovalDraft("updating"));
  LoggerGroup.emit("[i] Approving draft");
  log("approveDraft payload", payload);
  /*
    payload={
      "templateId":333,
      "emailRevisionId":1,
      "smsRevisionId":1,
      "templateAction":0,
      "comments":"approved",
      "emailTemplateId":87,
      "smsTemplateId":87,
      "approvedBy":"kashish"
    }
  */
  payload = JSON.stringify(payload);
  payload = encryption(process.env.REACT_APP_API_CRYPTO_KEY, payload);

  return axios({
    url: `/templates/approve-draft`,
    method: "post",
    params: {},
    data: payload,
  })
    .then((res) => {
      LoggerGroup.emit("Approve draft response", { dir: res });
      const templates = res.status;
      if (templates) {
        LoggerGroup.emit("  [i] Sending Approval to DB", { table: templates }).end();
        dispatch({ type: APPROVAL_DRAFT, template_editor_payload: res });
      }
    })
    .catch((err) => {
      LoggerGroup.emit(
        { warn: "[i] Error Getting Editor information" },
        { dir: err.response }
      ).end();
      dispatch({ type: APPROVAL_DRAFT_ERROR, payload: { template_editor_payload: err } });
    });
};

export const sendSampleCampaign = (campaign, seedList) => (dispatch) => {
  LoggerGroup.emit("Sending sample campaign");
  campaign = JSON.stringify(campaign);
  campaign = encryption(process.env.REACT_APP_API_CRYPTO_KEY, campaign);
  axios
    .post(`templates/send-samples`, { campaign, seedList })
    .then((res) => {
      const status = get(res, "data.status");
      if (status === "success") {
        const message = get(res, "data.message");
        let number = /\d+/;
        if (message.match(number) < 1) {
          toastr.error("Error sending SMS messages, try again in a few minutes.");
        } else {
          toastr.success("Success", message);
        }
      }
    })
    .catch((err) => {
      const error_message = get(err, "response.data.error");
      error("Error sending sample message", error_message || get(err, "response.data"));

      toastr.error(
        "Sorry",
        `There was an issue sending your sample campaign, please try again in a few minutes`
      );
    });
};

const getDeleteDrafts = (sms_payload, email_payload) => (dispatch) => {
  LoggerGroup.emit("[i] Deleting drafts");
  /*
  sms_payload={
    template_id="",
    revision_id=""
  }

  email_payload={
    template_id="",
    revision_id=""
    }
  */

  let requestArray = [];
  let sms;
  let email;

  if (sms_payload && sms_payload.revision_id) {
    sms = `/templates/delete-draft-by-template-and-revison/sms/${sms_payload.template_id}/${sms_payload.revision_id}`;
    requestArray.push(axios.delete(sms));
  }

  if (email_payload && email_payload.revision_id) {
    email = `/templates/delete-draft-by-template-and-revison/email/${email_payload.template_id}/${email_payload.revision_id}`;
    requestArray.push(axios.delete(email));
  }

  return axios
    .all(requestArray)
    .then(
      axios.spread((...responses) => {
        toastr.success(
          `
        Revision Deleted
        `,
          { timeOut: 10000, fadeOut: 10000 }
        );
      })
    )
    .catch((err) => {
      toastr.error("Delete Failed, try agian in a few mins");
      LoggerGroup.emit(
        { warn: "[i] Error Getting Editor information" },
        { dir: err.response }
      ).end();
    });
};

const handleCampaignLaunch = (type, subtype, user) => (dispatch) => {
  LoggerGroup.emit("[i] Creating On Demand Campaign");

  return axios({
    url: `templates/create-campaign`,
    method: "post",
    data: { type, subtype, user },
  })
    .then(
      axios.spread((...responses) => {
        toastr.success(
          `
      On Demand Campaign Created Successfully!
      `,
          { timeOut: 2000, fadeOut: 2000 }
        );
      })
    )
    .then(() => window.location.reload(true))
    .catch((err) => {
      toastr.error("Campaign Creation Failed, try agian in a few mins");
      LoggerGroup.emit(
        { warn: "[i] Error sending campaign information to server" },
        { dir: err.response }
      ).end();
    });
};

export const getOnDemandTemplates = (include = "active", user) => (dispatch) => {
  dispatch(templatesLoading("templates"));
  LoggerGroup.emit("[i] Updating list of templates");
  return axios({
    url: `templates/get-on-demand-templates`,
    method: "get",
    params: { include },
  })
    .then((res) => {
      const templates = get(res, "data.templates");
      if (templates) {
        for (let i = 0; i < templates.length; i++) {
          let data = templates[i];
          if (data.created_dt) {
            data.created_dt = moment(data.created_dt) //Launch date
              .tz("America/Chicago")
              .format("YYYY-MM-DD h:mm a");
          }

          if (
            data.proc_status === "" ||
            data.proc_status === null ||
            data?.proc_status.toLowerCase() === "completed"
          ) {
            data.launch = (
              <Button key={i} active onClick={handleCampaignLaunch(data.type, data.subtype, user)}>
                Launch
              </Button>
            );
          } else {
            data.launch = (
              <Button key={i} disabled>
                Launch
              </Button>
            );
          }
        }
        LoggerGroup.emit("  [i] List of On Demand templates", { table: templates }).end();
        dispatch({ type: SET_ON_DEMAND_TEMPLATES, payload: templates });
      }
    })
    .catch((err) => {
      LoggerGroup.emit({ warn: "[i] Error getting templates" }, { dir: err.response }).end();
      dispatch({ type: TEMPLATE_ERROR, payload: { template_payload: "Error getting templates" } });
    });
};
